import { Legend, Font } from 'pepsico-ds'
import { useTiersChart } from './useTiersChart'

const TIER_HEIGHT = '40px'

const Tier = ({ color, size, quantityLabel }) => {
  return (
    <section
      className="flex items-center justify-center"
      style={{ height: TIER_HEIGHT, width: `${size}%`, backgroundColor: color }}
    >
      <Font variant="bold" size="xxsmall" textColorClass="text-white">
        {quantityLabel}
      </Font>
    </section>
  )
}

const getLabelQuantity = num => (num / 1000 > 1 ? `${Math.floor(num / 1000)}K` : num)

const getTiersChart = list => {
  let totalStores = 0

  for (let i = 0; i < list?.length; i++) {
    const current = list[i]
    totalStores += current?.storesAssociated
  }

  return {
    totalStores: getLabelQuantity(totalStores),
    list: list.map(item => ({
      ...item,
      size: (item.storesAssociated / totalStores) * 100,
      quantityLabel: getLabelQuantity(item?.storesAssociated || 0),
    })),
  }
}

const mapTiersToLegendItems = tiers => {
  return tiers.map(tier => ({
    color: `#${tier.color}`,
    label: tier.name,
  }))
}

export const TiersChart = () => {
  const { tiers } = useTiersChart()
  const tierData = getTiersChart(tiers || [])
  const legendItems = mapTiersToLegendItems(tiers || [])

  return (
    <section className="my-4 flex flex-col items-center">
      <section className="mb-5 flex w-full items-center justify-center">
        <Font variant="bold" size="xxsmall" textColorClass="text-white" className="mx-3">
          Tiers
        </Font>
        {tierData.list.map(item => (
          <Tier
            key={item.name}
            color={"#" + item.color}
            size={item.size}
            quantity={item.storesAssociated}
            quantityLabel={item.quantityLabel}
          />
        ))}
        <Font variant="bold" size="xxsmall" textColorClass="text-white" className="mx-3">
          {tierData.totalStores}
        </Font>
      </section>
      <Legend isDark className="" direction="horizontal" items={legendItems} style={{}} />
    </section>
  )
}
